/* eslint-disable */
import {lista, pegaDados, pegaLista, processaArquivo} from '../../services/GenericAPI'
import {Filtro} from "../../models/filtro/filtro";

const url = '/servicos'

const state = {
   all: [],
   allList: [],
   filtro: new Filtro()
}

const getters = {
   listaAllServicos: (state) => {
      return state.allList
   },
}

const actions = {
   async setAllListServicos({commit}, {filtro, onSucesso,onErro}) {
      try {
         const list = (await pegaDados(url + '/get_all', filtro)).data
         commit('SET_ALL_LIST', list)
         onSucesso()
      } catch (error) {
         onErro()
         console.log('error: ',error)
      }
   },

   async processarArquivosServicos({commit}, {filtro,onSucesso,onErro}) {
      try {
         const list = (await processaArquivo(url + '/get_pdf', filtro))
         onSucesso(list)
      } catch (error) {
         onErro()
         console.log('error: ',error)
         this.dispatch('geral/setObjMsgError', error.response.data)
      }
   },
}

const mutations = {

   SET_ALL_LIST(state, filtro) {
      state.allList = filtro
   },
   SET_FILTRO(state, filtro) {
      state.filtro = filtro
   },
}

export default {
   namespaced: true,
   state,
   getters,
   actions,
   mutations
}
